export default __webpack_public_path__ + "static/media/cp_geo_lr.4af9961b.svg";